export const ENTERED_IN_ERROR_STATUS = 'ERR';
export const BOARD_PENDING_MEETING_STATUS = 'BPM';
export const APPROVED_STATUS = 'BA';
export const REJECTED_STATUS = 'BD';
